import React, { createContext, useState } from "react";

import { torontoToday } from "../utils/TorontoTime";

export const AppContext = createContext({});

export const createBookingFilters = () => {
  return { date: torontoToday(), dateFilterEnabled: false, rideId: null, status: "All" };
};

export const AppContextProvider = ({ children }) => {
  // Keep filters across route changes, but reset when the app reloads.
  const [bookingFilters, setBookingFilters] = useState(createBookingFilters);
  const [isopenMenu, setisopenMenu] = useState(false);
  const [theme, settheme] = useState(
    localStorage.getItem("diary-theme") ?? "default"
  );
  const value = {
    bookingFilters,
    setBookingFilters,
    isopenMenu,
    setisopenMenu,
    theme,
    settheme,
  };
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
